import { getEntitySubAccountNames, type AllocationBE } from './Allocation';
import type { ModeEnum, SubAccountTradeRoutingModeEnum, TransactionControlTypeEnum, UpdateActionEnum } from './types';

export class SubAccountAllocationControl {
  Timestamp!: string;
  RuleID!: string;
  Revision!: number;

  Mode!: ModeEnum;
  MatchMarket?: string;
  MatchMarketAccount?: string;
  MatchAsset?: string;
  MatchTransactionType?: TransactionControlTypeEnum;
  AllocationMode?: SubAccountTradeRoutingModeEnum;
  UpdateAction!: UpdateActionEnum;
  UpdateUser?: string;
  SubAccount?: string;
  Allocation?: AllocationBE;
  /** An array of all the sub accounts used. For allocs, will be the alloc members. If no allocs, will just be the sub account in an array. Else undefined. */
  subAccounts: string[] | undefined;

  constructor(data: SubAccountAllocationControl) {
    Object.assign(this, data);
    this.subAccounts = getEntitySubAccountNames(data);
  }
}
